import { Route, Switch, useLocation } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { FaListUl } from 'react-icons/fa';
import { GoGear } from 'react-icons/go';
import { GiCardboardBoxClosed } from 'react-icons/gi';
import { useHistory } from 'react-router';
import { useSpotlightActions } from '../../AppSpotlight';

MenuManager.RegisterGroup({
		key: 'Products',
		name: 'Товары',
		icon: <GiCardboardBoxClosed />,

		position: 5
	},
	[
		{
			path: '/products',
			name: 'Товары',
			position: 0,
			icon: <FaListUl />
		},
		{
			icon: <GoGear />,
			path: `/products/categories`,
			position: 1,
			name: 'Категории'
		},
		{

			path: `/products/nutItems`,
			position: 2,
			name: 'Пищевые ценности'
		},
		{

			path: `/products/compositions`,
			name: 'Состав товара (Элементы)',
			position: 3
		},
		{
			path: `/products/tags`,
			name: 'Теги',
			position: 4
		}
	]);

const ProductsRoute = (props) => {
	const location = useLocation();
	const history = useHistory();
	const basePath = props.path || '/products';
	const getPath = (path = '') => `${basePath}${path}`;

	const List = useLoadComponent(() => import('./List').then((res) => res.ListProductsPage), {
		basePath
	});

	const SortRootCatalog = useLoadComponent(() => import('./sort/rootCatalog').then((res) => res.SortRootCatalog), {
		basePath
	});
	const SortCatalog = useLoadComponent(() => import('./sort/catalog').then((res) => res.SortCatalog), {
		basePath
	});
	const View = useLoadComponent(() => import('./View').then((res) => res.View), {
		basePath
	});

	const Editor = useLoadComponent(() => import('./Edit').then((res) => res.Edit), {
		basePath
	});
	const NutItems = useLoadComponent(() => import('./NutItems/ListAsEditableTable').then((res) => res.NutItemsListAsEditableTable), {
		basePath
	});
	const Compositions = useLoadComponent(() => import('./Compositions/CompositionsRoute').then((res) => res.CompositionsRoute), {
		path: getPath('/compositions')
	});

	const Categories = useLoadComponent(() => import('./Categories/CategoriesRoute').then((res) => res.CategoriesRoute), {
		path: getPath('/categories')
	});
	const Tags = useLoadComponent(() => import('./Tags/TagsRoute').then((res) => res.TagsRoute), {
		path: getPath('/tags')
	});
	const unregisteredMSProducts = useLoadComponent(() => import('./unregisteredMSProducts').then((res) => res.UnregisteredMSProducts), {});

	useSpotlightActions([{
		id: 'products.page',
		title: 'Товары',
		icon: <GiCardboardBoxClosed />,
		onTrigger: () => history.push(getPath())
	}, {
		id: 'products.edit',
		title: 'Открыть продукт по ссылке',
		icon: <GiCardboardBoxClosed />,
		special: true,
		match: (qs) => {
			if (qs.includes('/p/')) {
				const re = /(?<slug>.*)-(?<id>[a-fA-F0-9]{24})$/gm;
				const result = re.exec(qs);
				if (result) return { match: true, onTrigger: () => history.push(getPath(`/edit/${result.groups.id}`)) };
			}
		}
	}]);

	return (
		<>
			<Route
				exact={!location.pathname.includes(getPath('/view'))}
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					path={getPath('/unregisteredMsProducts')}
					component={unregisteredMSProducts}
				/>
				<Route
					path={getPath('/sort/rootCatalog')}
					component={SortRootCatalog}
				/>
				<Route
					path={getPath('/sort/catalog')}
					component={SortCatalog}
				/>
				<Route
					path={getPath('/tags')}
					component={Tags}
				/>
				<Route
					path={getPath('/categories')}
					component={Categories}
				/>
				<Route
					path={getPath('/compositions')}
					component={Compositions}
				/>
				<Route
					exact
					path={getPath('/nutItems')}
					component={NutItems}
				/>
				<Route
					exact
					path={getPath('/view/:id')}
					component={View}
				/>
				<Route
					exact
					path={getPath('/edit/:id')}
					component={Editor}
				/>
			</Switch>
		</>
	);
};

ProductsRoute.propTypes = {
	path: PropTypes.string
};

export { ProductsRoute };
